<template>
<div class="country-page" :class="{'first-loaded': firestLoaded}">

  <div class="product-list-box" v-if="countryInfo && countryInfo.status === 0">
    <country-top
      :country-info="countryInfo"
      :holiday-arr="holidayArr"
      :province-code.sync="params.province_code"
      :visa-type.sync="params.visa_type"
      :entry-count-type.sync="params.entry_count_type"
      :product-list="productList"
      @update:provinceCode="changeParams"
      @update:visaType="changeParams"
    ></country-top>

    <product-list
      :country-info="countryInfo"
      :product-list="productList"
      :province-code="params.province_code"
      :entry-count-type="params.entry_count_type"
    ></product-list>
  </div>

  <div class="nodata" v-else-if="countryInfo && countryInfo.status === 1">
    <!-- 下架 -->
    <img class="nodata-img" src="../../assets/imgs/product-detail/nodata-product.png" alt="">
    <div class="nodata-text">暂无数据</div>
  </div>

  <!-- 国家公告 -->
  <country-popup-dialog
    ref="countryPopupDialog"
    :visa_country_id="visa_country_id"
    :province_code="params.province_code"
  ></country-popup-dialog>

  <!-- 固定右侧 -->
   <country-fix-right v-if="countryInfo" :country-info="countryInfo" :visa_country_id="visa_country_id"  :product-list="productList"></country-fix-right>
</div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

import { mapActions } from 'vuex';
import CountryTop from './components/country-top';
import utils from '../../libs/utils';
import User from '../../libs/user';
import Http from '../../libs/http';
import addNewOrderService from '../../services/add-new-order-service';
import ProductList from './components/product-list';
import CountryPopupDialog from './components/country-popup-dialog.vue';
import browserService from '../../services/browser-service';
import CountryFixRight from './components/country-fix-right.vue';
import CountryFilter from './components/country-filter.vue';

export default {
  name: '',
  components: {
    CountryTop,
    CountryPopupDialog,
    ProductList,
    CountryFixRight,
    CountryFilter,
  },
  data() {
    return {
      firestLoaded: false,
      visa_country_id: 0,
      params: {
        province_code: 0,
        visa_type: '',
        entry_count_type: 0, // 0 不过滤， 1 单次  2多次和其他
      },
      holidayArr: [], // 使馆放假日历
      provinces: {}, // 省份
      pcds: {}, // 省市区
      noticeList: [], // 国家公告
      productList: [], // 后端查到的数据, 包含国家信息和商品列表等
      countryInfo: null, // 国家信息
    };
  },
  computed: {},
  watch: {
    '$route.params.id': function () {
      if (+this.$route.params.id !== this.visa_country_id) {
        // 国家替换，重新请求, 去除签证类型选中
        this.params.visa_type = '';
        this.addUrlQuery();
        this.init();
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('user', [
      'getIPLocation',
    ]),

    init() {
      this.visa_country_id = +this.$route.params.id;
      this.params.visa_type = this.$route.query.visa_type || undefined;
      this.params.province_code = this.$route.query.province_code ? +this.$route.query.province_code : 0;
      this.params.entry_count_type = 0;
      this.countryInfo = null;

      if (!this.visa_country_id) {
        return;
      }

      this.initProvinceCode().then(() => {
        this.loadCountryData().then(() => {
          sensorsdata.track('PC_Country_Page', {
            country: this.countryInfo ? this.countryInfo.country : '',
          });

          const countryName = this.countryInfo ? this.countryInfo.country : '';

          browserService.setHtmlSeo({
            keywords: `上上签,签证办理,${countryName}签证,${countryName}旅游签,${countryName}商务签`,
            description: `上上签是国内领先的签证办理平台，为同业提供专业全球签证办理。上上签提供${countryName}签证办理，包括个人签证、旅游签证、商务签证、探亲访友签等签证类型，还可查询${countryName}领馆假期、${countryName}签证资料清单、${countryName}签证办理条件、${countryName}签证办理费用、${countryName}签证出行日期`,
          });
        });
      });
      this.getHoliday();

      this.xbbRecord();

      // 工单埋点
      this.workOrderRecord();
    },

    // 工单埋点
    workOrderRecord() {
      // 销帮帮记录埋点
      if (User.isLogin()) {
        Http.post('/peer_behavior_record_add', {
          visa_country_id: this.visa_country_id, // 国家id, behavior_type_id = 10001必填
          behavior_type_id: 10001, // 10001:浏览商品列表页, 10002:浏览商详页, 10003:添加申请人, 10007:分享商详页, 10008:分享店铺
        });
      }
    },

    // 肖帮帮埋点
    xbbRecord() {
      // 销帮帮记录埋点
      if (User.isLogin()) {
        Http.post('/xbb_record_add', {
          record_type: 7,
          visa_country_id: this.visa_country_id,
        });
      }
    },

    // 加载页面数据
    loadCountryData() {

      return this.getCountryInfo()
        .then(() => this.getProductList())
        .then(() => {
          this.addUrlQuery();
        });
    },

    // 初始化省份code
    initProvinceCode() {
      return new Promise((resolve) => {
        if (this.params.province_code) return resolve();

        const query_province_code = this.$route.query.province_code;
        // 当前url如果有省份信息则选中这个省份
        if (query_province_code && +query_province_code) {
          this.params.province_code = +query_province_code;
          resolve();
          return;
        }

        // 没登录通过IP获取
        this.getIPLocation().then((res) => {
          this.params.province_code = +res.province_code || 440000;
          resolve();
        }).catch(() => {
          if (User.isLogin()) {
            // ip在获取不到，就去取同业地址
            Http.post('/visa_peer_query', {}).then((peer) => {
              this.params.province_code = +peer.province_code;
              resolve();
            }).catch(() => {
              this.params.province_code = 440000;
              resolve();
            });
          } else {
            this.params.province_code = 440000;
            resolve();
          }
        });
      });
    },

    // 加载国家放假日历
    getHoliday() {
      addNewOrderService
        .getProductHolidays(this.visa_country_id)
        .then((data) => {
          if (!Object.keys(data).length) return;
          const holidays = data[Object.keys(data)[0]];
          this.holidayArr = addNewOrderService.handleShowHolidayArr(holidays);
        })
        .catch((e) => {
          if (e) console.log(e);
          utils.msg.error('获取国家放假日历失败');
        });
    },

    getCountryInfo() {
      return new Promise((resolve, reject) => {

        Http.post('/sys/visa_country_query', {
          visa_country_id: this.visa_country_id,
          province_code: this.params.province_code,
        }).then((res) => {
          this.countryInfo = res;
          // 初始化选中签证类型
          if (!this.params.visa_type || this.countryInfo.visa_type_list.indexOf(this.params.visa_type) === -1) {
            this.params.visa_type = this.countryInfo.visa_type_list[0];
          }
          resolve();

        }).catch(() => {
          reject();
        });
      });
    },

    // 获取商品列表
    getProductList() {
      const params = {
        visa_country_id: this.visa_country_id,
        province_code: this.params.province_code,
        visa_type: this.params.visa_type,
      };
      this.productList = [];
      if (!this.params.visa_type) {
        this.firestLoaded = true;
        return Promise.resolve();
      }
      return Http.post('/sys/visa_product_brief_query', params).then((res) => {
        this.productList = res.product_list;
        this.firestLoaded = true;
        // 国家公告
        this.$refs.countryPopupDialog.initPopupDialog();
      }).catch((e) => {
        if (e && e.msg) {
          utils.msg.error(e.msg);
        } else {
          utils.msg.error('加载数据失败');
        }
      });
    },

    // 更改参数
    changeParams() {
      this.params.entry_count_type = 0;
      this.addUrlQuery();
      // 重新获取国家信息和商品列表
      this.loadCountryData();
    },


    // 往url里面添加参数
    addUrlQuery() {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query.province_code = this.params.province_code;
      query.visa_type = this.params.visa_type || undefined;

      this.$router.replace({ query });
    },
  },
};
</script>

<style scoped lang="less">
.country-page{
  width: 1120px;
  margin: 0 auto;
  padding: 210px 0 60px 0;
  height: 100vh;
  &.first-loaded{
    height: auto;
  }
  &::after {
    content: "";
    position: fixed;
    right: 0;
    top: 68px;
    width: 100%;
    height: 16px;
    z-index: 10;
    background: #f7f8fa;
  }
  .nodata{
    margin-top: 12px;
    width: 100%;
    height: 443px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 74px;
    .nodata-img{
      width: 200px;
      height: 132px;
    }
    .nodata-text{
      margin-top: 16px;
      font-size: 16px;
      color: #91999F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/country/Country.vue